import {ColorValue, StyleSheet, TextStyle} from 'react-native';
import {RoundedBtnDescriberProps} from 'src/components/elements/buttonDescriptor/DescriptorType';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {ButtonType} from 'src/components/elements/RoundedButton';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const {primaryColor} = getLayoutDescriber();

export function roundedBtnColorDescriptor(props: RoundedBtnDescriberProps): {
  [index: string]: ColorValue;
} {
  const disabledColor = Styles.lightGray;
  const buttonColor = props.disabled
    ? disabledColor
    : props.color || primaryColor();
  let fillColor = primaryColor();
  let textColor = Styles.white;

  if (props.buttonType === 'outline') {
    fillColor = Styles.transparent;
    textColor = props.disabled ? disabledColor : props.color || primaryColor();
  } else {
    fillColor = props.disabled ? disabledColor : props.color || primaryColor();
    textColor = Styles.white;
  }
  return {fillColor, textColor, buttonColor};
}

export function roundAppButtonSolidTextStyle(_disabled: boolean): TextStyle {
  return null;
}

export function roundAppButtonOutlineTextStyle(_disabled: boolean): TextStyle {
  return null;
}

export function checkRoundedBtnColor(_type?: ButtonType): string {
  return Styles.Colors.Aramark.primary;
}

export function getSaveBtnManageAccount(
  handleSave,
  checkDisabled: () => boolean,
) {
  return (
    <RoundedAppButton
      buttonContainerStyle={styles.buttonContainer}
      buttonViewStyle={styles.buttonView}
      textStyle={styles.buttonText}
      isDisabled={checkDisabled()}
      inActiveButtonViewStyle={styles.inActiveButtonView}
      inActiveTextStyle={styles.inActiveText}
      buttonType={RoundedAppButtonType.Solid}
      titleText={Localized.Buttons.save}
      onPress={handleSave}
      accessibilityLabelValue={Localized.Buttons.save}
      aria-label={Localized.Buttons.save}
      testID="qa_btn_Save"
    />
  );
}

export function getTertiaryCTATextStyle(): TextStyle {
  return null;
}

export function buttonTextFontFamily(): string {
  return Styles.FontFamily.gothamRegular;
}
export function redeemRewardRoundedBtnColor(_type?: ButtonType): string {
  return Styles.Colors.Aramark.primary;
}

export function redeemRewardIconColor(): string {
  return Styles.Colors.Aramark.primary;
}

const styles = StyleSheet.create({
  inActiveText: {
    fontSize: Styles.Fonts.f1,
    marginHorizontal: Styles.Spacing.m2,
  },
  inActiveButtonView: {
    backgroundColor: Styles.Colors.PayNew.darkHuesBase04,
    height: 46,
  },
  buttonText: {
    fontSize: Styles.Fonts.f1,
    marginHorizontal: Styles.Spacing.m2,
  },
  buttonContainer: {
    right: Styles.Spacing.m3,
    bottom: Styles.Spacing.m3,
    position: 'absolute',
  },
  buttonView: {
    height: 46,
  },
});

export default {
  roundedBtnColorDescriptor,
  roundAppButtonSolidTextStyle,
  roundAppButtonOutlineTextStyle,
  checkRoundedBtnColor,
  getSaveBtnManageAccount,
  getTertiaryCTATextStyle,
  buttonTextFontFamily,
  redeemRewardRoundedBtnColor,
  redeemRewardIconColor,
};
